export default "__VITE_ASSET__B7AMXC1V__"